export default class AuthError extends Error {
  constructor(readonly code: string, description) {
    super(description)
    this.name = 'AuthError'
  }
}
